import Loadable from 'react-loadable';
import Loading from '../components/layout/Loading';

const loadable = (fn) =>
  Loadable({
    loader: fn,
    loading: Loading,
  });

export default loadable;
